module.exports = __webpack_public_path__ + "img/41_47.05423711.png";